import styled from "styled-components";

export const CardsContainer = styled.div`
  display: flex;
  align-items: center; /* ✅ centers image with text */
  gap: 12px;
  padding: 12px 16px;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  max-width: 900px;

  .card-image {
    width: 40px;
    height: 40px;
    object-fit: contain;
    flex-shrink: 0;
  }

  .card-text {
    font-size: 14px;
    line-height: 1.5;
    margin: 0;
  }

  .card-title {
    font-weight: 600;
    color: #111827;
  }

  .card-description {
    font-weight: 400;
  }
`;
